import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

export const onRouteUpdate = () => {
    /* ------------------------------
   * フェード系
   * ------------------------------ */
  if ("IntersectionObserver" in window) {
    const elements = document.querySelectorAll(
      ".fadeInUp, .fadeInRight, .fadeInLeftToRight"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("on");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    elements.forEach((el) => observer.observe(el));

         // 2. ページロード後にコンテンツ表示
  const loader = document.getElementById("loader");
  const content = document.getElementById("content");

  const showContent = () => {
    if (loader) loader.style.display = "none";
    if (content) {
      content.classList.remove("hidden");
      const animates = content.querySelectorAll(".animate");
      animates.forEach((el, i) => {
        setTimeout(() => {
          el.classList.add("loaded");
        }, i * 150); // 0.15秒ずつ遅延
      });
    }
  };

  if (document.readyState === "complete") {
    // すでにロード済みの場合
    showContent();
  } else {
    window.addEventListener("load", showContent);
  }

  // クリーンアップ
  return () => {
    elements.forEach((el) => observer.unobserve(el));
    window.removeEventListener("load", showContent);
  };


        return () => {
            elements.forEach((el) => observer.unobserve(el));
        };
    }
};

export const onClientEntry = () => {
  if (typeof document !== "undefined") {
    document.documentElement.classList.add("js");
  }
};
